import React, { Component } from "react";
import Predefine_3_VNeck_Cricket from "../components/Predefine_3_VNeck_Cricket/Predefine_3_VNeck_Cricket";

export class Predefine_3_VNeck_CricketPage extends Component {
  render() {
    return <Predefine_3_VNeck_Cricket />;
  }
}

export default Predefine_3_VNeck_CricketPage;
